import React from "react";
import { useFieldArray } from "react-hook-form";
import { FieldSet } from "src/components/event_transaction/components/shared/Form/FieldSet";
import { Text } from "src/components/ui/Text";
import { AddIcon, DeleteIcon } from "src/components/event_transaction/icons";
import clsx from "clsx";
import { IconButton } from "src/components/ui/baseButton";
import { groupOptionRefrigerant } from "./groupOptionData";

const AirConditionerListsForm = (props) => {
  const { control, watch, disabled, defaultAirConditionerList } = props;
  const watchFieldArray = watch("airConditionerList");

  const {
    fields: airConditionerList,
    append: appendAirConditionerList,
    remove: removeAirConditionerList,
  } = useFieldArray({ name: "airConditionerList", control });

  const controlledFields = airConditionerList.map((field, index) => ({
    ...field,
    ...watchFieldArray?.[index],
  }));

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-2">
        <Text variant="bold-14">List of Air Conditioners</Text>
        <Text variant="normal-10">
          Please enter the BTU, compressor, and amount of the air conditioners
        </Text>
      </div>

      <div className="flex flex-col gap-2">
        {controlledFields.map((item, index) => {
          return (
            <div
              key={item?.id}
              className={`grid grid-cols-3 gap-2 items-center relative ${clsx(
                airConditionerList.length > 1 && "pr-10"
              )}`}
            >
              <FieldSet
                required
                disabled={disabled}
                name={`airConditionerList.${index}.airConditionerBTU`}
                type="textNumeric"
                control={control}
                label="Air Conditioner (BTU)"
                unit="BTU"
                placeholder={
                  !disabled ? "Please enter air conditioner BTU" : ""
                }
                thousandSeparator
              />

              <FieldSet
                required
                disabled={disabled}
                name={`airConditionerList.${index}.airConditionerRefrigerant`}
                type="autocomplete"
                control={control}
                label="Refrigerant"
                placeholder={!disabled ? "Please select refrigerant" : ""}
                groupOptions={groupOptionRefrigerant}
              />

              <FieldSet
                disabled={disabled}
                name={`airConditionerList.${index}.airConditionerAmount`}
                type="number"
                control={control}
                label="Amount"
                placeholder={!disabled ? "Please enter amount" : " "}
              />

              {airConditionerList.length > 1 && !disabled ? (
                <IconButton
                  className="absolute right-0 top-[0.55rem] cursor-pointer hover:bg-red-50 rounded w-8 h-8"
                  onClick={() => removeAirConditionerList(index)}
                >
                  <img src={DeleteIcon} alt="deleteIcon" className="w-5 h-5" />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          );
        })}

        {!disabled && (
          <div
            className="w-full h-full pr-3 bg-white rounded-md border border-quinary px-2 py-4 flex gap-2 items-center cursor-pointer"
            onClick={() => appendAirConditionerList(defaultAirConditionerList)}
          >
            <img src={AddIcon} alt="addIcon" className="w-3 h-3" />
            <Text variant="normal-14" className="">
              Add more air conditioners
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default AirConditionerListsForm;
